import React from 'react';
import { Box, Container, Typography, Button, Card, CardContent } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CheckCircleOutline as CheckCircleOutlineIcon } from '../icons';

/**
 * Account Deleted Confirmation Page
 * 
 * Shown after successful account deletion.
 * Provides confirmation and option to return to homepage.
 */
function AccountDeleted() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        py: 4
      }}
    >
      <Container maxWidth="sm">
        <Card 
          elevation={2}
          sx={{ 
            borderRadius: '12px',
            overflow: 'visible'
          }}
        >
          <CardContent sx={{ p: 4, textAlign: 'center' }}>
            {/* Success Icon */}
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 80,
                height: 80,
                borderRadius: '50%',
                backgroundColor: '#e8f5e9',
                mb: 3
              }}
            >
              <CheckCircleOutlineIcon 
                sx={{ 
                  fontSize: 48,
                  color: '#4caf50'
                }} 
              />
            </Box>

            {/* Title */}
            <Typography 
              variant="h4" 
              sx={{ 
                fontWeight: 600,
                color: '#1f2937',
                mb: 2
              }}
            >
              Account Deleted
            </Typography>

            {/* Description */}
            <Typography 
              variant="body1" 
              sx={{ 
                color: '#6b7280',
                mb: 1,
                lineHeight: 1.6
              }}
            >
              Your account and all associated data have been permanently deleted.
            </Typography>

            <Typography 
              variant="body1" 
              sx={{ 
                color: '#6b7280',
                mb: 4,
                lineHeight: 1.6
              }}
            >
              Thank you for using myStack. We're sorry to see you go.
            </Typography>

            {/* Return to Home Button */}
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate('/')}
              sx={{
                backgroundColor: '#007AFF',
                color: 'white',
                textTransform: 'none',
                borderRadius: '8px',
                px: 4,
                py: 1.5,
                fontWeight: 500,
                fontSize: '1rem',
                '&:hover': {
                  backgroundColor: '#0056CC'
                }
              }}
            >
              Return to Home
            </Button>

            {/* Support Info */}
            <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid #e5e7eb' }}>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: '#9ca3af',
                  fontSize: '0.875rem'
                }}
              >
                Changed your mind? Contact us at{' '}
                <a 
                  href="mailto:contact@my-stack.ai"
                  style={{
                    color: '#007AFF',
                    textDecoration: 'none',
                    fontWeight: 500
                  }}
                >
                  contact@my-stack.ai
                </a>
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
}

export default AccountDeleted;



